// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadPhotoTimelineDialog {
  display: flex;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: center;
}

.dialog {
  width: 500px;
  max-height: 580px;
  background-color: white;
  border-radius: 32px;
  padding: 26px 16px 7px 16px;
  margin: 26px;
}

.uploadPhotoTimelineDialog nav {
  display: flex;
}
.uploadPhotoTimelineDialog nav p {
  text-align: center;
  width: 100%;
}
.icon {
  width: 48px;
}
.uploadPhotoTimelineDialog .photosList {
  height: 400px;
  overflow: auto;
  scrollbar-width: none;
}
.uploadPhotoTimelineDialog .photosList::-webkit-scrollbar {
  width: 0; /* Hide Chrome/WebKit scrollbar */
}

.uploadPhotoTimelineDialog .uploadPhotoBottom{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 0;
    margin-top: 26px;
}
.uploadPhotoTimelineDialog .addPhotoButton{
    color:  #4795DE;
    outline: none;
    flex: 1 1;
    background: transparent;
    padding: 4px 26px;
    text-align: start;
}
.uploadPhotoTimelineDialog .postButton{
    border-radius: 26px;
    background-color:  #6CA8E1;
    color: white;
    border: none;
    flex: 1 1;
    max-width: 100px;
    padding: 4px 26px;
}

.uploadPhotoTimelineDialog .empty{
  flex: 1 1;
  padding: 4px 26px;
}



`, "",{"version":3,"sources":["webpack://./src/styles/uploadPhotoTimelineStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,QAAQ,EAAE,iCAAiC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,aAAa;IACb,SAAO;IACP,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,SAAO;IACP,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB","sourcesContent":[".uploadPhotoTimelineDialog {\r\n  display: flex;\r\n  position: fixed;\r\n  z-index: 100;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.dialog {\r\n  width: 500px;\r\n  max-height: 580px;\r\n  background-color: white;\r\n  border-radius: 32px;\r\n  padding: 26px 16px 7px 16px;\r\n  margin: 26px;\r\n}\r\n\r\n.uploadPhotoTimelineDialog nav {\r\n  display: flex;\r\n}\r\n.uploadPhotoTimelineDialog nav p {\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n.icon {\r\n  width: 48px;\r\n}\r\n.uploadPhotoTimelineDialog .photosList {\r\n  height: 400px;\r\n  overflow: auto;\r\n  scrollbar-width: none;\r\n}\r\n.uploadPhotoTimelineDialog .photosList::-webkit-scrollbar {\r\n  width: 0; /* Hide Chrome/WebKit scrollbar */\r\n}\r\n\r\n.uploadPhotoTimelineDialog .uploadPhotoBottom{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 12px 0;\r\n    margin-top: 26px;\r\n}\r\n.uploadPhotoTimelineDialog .addPhotoButton{\r\n    color:  #4795DE;\r\n    outline: none;\r\n    flex: 1;\r\n    background: transparent;\r\n    padding: 4px 26px;\r\n    text-align: start;\r\n}\r\n.uploadPhotoTimelineDialog .postButton{\r\n    border-radius: 26px;\r\n    background-color:  #6CA8E1;\r\n    color: white;\r\n    border: none;\r\n    flex: 1;\r\n    max-width: 100px;\r\n    padding: 4px 26px;\r\n}\r\n\r\n.uploadPhotoTimelineDialog .empty{\r\n  flex: 1;\r\n  padding: 4px 26px;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
